module.exports = "https://cdn.littlereply.com/tt/resource/icon_post_comment.efd0457120a2a012d8b158fe1ba1af1d.png";